// extracted by mini-css-extract-plugin
export default {"label":"mAQ63uXHzEkGMF2SMjng","label_error":"TwSz22UaM59SyktMeqWC"};